<template>
<div>
  <v-layout class="mt-4">
    <v-flex xs4 sm2>
      <v-select
        no-data-text="Nenhum ano disponível"
        append-icon="arrow_drop_down"
        label="Escolha um ano"
        item-value="ano"
        item-text="ano"
        :items="anos"
        v-model="currentYear"
        :loading="loadingAnos"
        solo
        single-line
      />
    </v-flex>
    <v-flex>
      <v-select
        no-data-text="Nenhum calendário disponível"
        append-icon="date_range"
        label="Escolha um calendário"
        item-value="cdcalen"
        item-text="dscalen"
        :items="calendarios"
        v-model="calendarioAtual"
        :loading="loadingCalendarios"
        solo
        single-line
      />
    </v-flex>
  </v-layout>
  <v-card style="position: relative;" wrap>
    <v-layout align-center justify-space-between class="calen_title">
      <v-flex
        sm5
        xs12
        class="text-sm-right"
      >
        <v-btn icon color="white" :disabled="numMesAtual == 1 || calendarioAtual == null" @click="$refs.calendar.prev()">
          <v-icon dark >
            keyboard_arrow_left
          </v-icon>
        </v-btn>
      </v-flex>
      <v-flex>
        <h2 class="text-xs-center calend_title_mes text-center">
          {{ mesAtual }} / {{currentYear}}
        </h2>
      </v-flex>
      <v-flex
        sm5
        xs12
        class="text-xs-left"
      >
        <v-btn icon color="white" :disabled="numMesAtual == 12 || calendarioAtual == null" @click="$refs.calendar.next()">
          <v-icon dark>
            keyboard_arrow_right
          </v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-flex xs12>
      <v-sheet height="800">
        <v-progress-linear v-if="loading" class="ma-0 w-100 calendar-progress" :indeterminate="true"></v-progress-linear>
        <v-calendar
          v-model="current"
          type="month"
          locale="pt-BR"
          ref="calendar"
          class="calend_body"
          start="2019-01-01"
          @change="getDates"
          end="2019-12-31"
        >
           <template v-slot:day="{ past, date }">
              <template v-if="past && eventsMap[date]">
                <v-menu
                  :key="event.titulo"
                  v-model="event.open"
                  offset-x
                  v-for="event in eventsMap[date]"
                >
                  <template v-slot:activator="{ on, attrs }">
                      <div
                        v-if="!event.time"
                        v-ripple
                        :style="{'backgroundColor': event.color}"
                        class="my-event"
                        v-html="event.titulo"
                        v-bind="attrs"
                        v-on="on"
                      ></div>
                  </template>
                    <v-card
                      color="grey lighten-4"
                      min-width="350px"
                    >
                      <v-toolbar
                        :color="event.color"
                      >
                        <v-toolbar-title class="text-capitalize" style="background-color: rgba(255, 255, 255, 0.7); padding: 3px 8px; border-radius: 15px;">{{date | formatdate(date)}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon>
                          <v-icon>more_vert</v-icon>
                        </v-btn>
                      </v-toolbar>
                      <v-card-title primary-title class="text-body-2">
                        <span> {{event.titulo}} </span>
                      </v-card-title>
                      <v-card-actions>
                        <v-btn
                          color="#3b8f97"
                          text
                          class="font-weight-regular"
                        >
                          Fechar
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                </v-menu>
              </template>
            </template>
        </v-calendar>
      </v-sheet>
    </v-flex>
    <div v-show="calendarioAtual === null" class="overlay"></div>
  </v-card>
</div>
</template>

<script>
import moment from 'moment';
import calendarioRepository from '@/repositories/calendarioRepository.js';

moment.locale('pt-br');

export default {
  data: () => ({
    calendarios : [],
    anos: [],
    loadingCalendarios : false,
    loadingAnos : false,
    calendarioAtual : null,
    current: moment().format('YYYY-MM-DD'),
    currentYear : moment().format('YYYY'),
    dates: [],
    loading: false,
  }),
  async created() {
    await this.getAnos();
    await this.getCalendars();
  },
  methods: {
    async getDates() {
      this.loading = true;
      this.dates = [];
      const { data } = await calendarioRepository.getDatas(this.calendarioAtual, this.currentYear, this.numMesAtual);

      this.dates = data.map(d => {d.open = false; return d;});
      this.loading = false;
    },
    async getCalendars(){
      this.loadingCalendarios = true;
      this.calendarios = [];
      this.calendarioAtual = null;
      const { data } = await calendarioRepository.getCalendarios(this.currentYear);
      this.calendarios = data;
      this.loadingCalendarios = false;
      return true;
    },
    async getAnos(){
      this.loadingAnos = true;
      const { data } = await calendarioRepository.getAnosCalendarios();
      this.anos = data;
      this.loadingAnos = false;
      this.currentYear = this.anos[0];
      return true;
    }
  },
  filters: {
    formatdate(date){
      return moment(date).format('DD [de] MMMM [de] YYYY');
    }
  },
  computed: {
    mesAtual() {
      if(typeof this.current === 'object') { this.current = this.current.date; }
        return moment(this.current).format('MMMM');
    },
    numMesAtual(){
      if(typeof this.current === 'object') { this.current = this.current.date; }
        return moment(this.current).format('MM');
    },
    eventsMap () {
      const map = {}
      this.dates.forEach(e => {
        const ano = e.ano.toString().padStart(2, '0');
        const mes = e.mes.toString().padStart(2, '0');
        const dia = e.dia.toString().padStart(2, '0');

        const data = `${ano}-${mes}-${dia}`;
        if (!map[data])
          map[data] = [];

        map[data].push(e);
      });
      return map
    },
  },
  watch: {
    current(newV, prev){
      if (parseInt(moment(newV).format('YYYY')) !== this.currentYear){
        this.current = prev;
      }
    },
    calendarioAtual(){
      this.getDates();
    },
    currentYear(){
      this.getCalendars();
    }
  }
}
</script>

<style lang="scss">
.v-calendar-weekly__head{
  text-align: center;
    box-shadow: 0 3px 3px rgba(0, 0, 0, 0.2);
    z-index: 1;
  .v-calendar-weekly__head-weekday{
    padding: 10px 0;
  }
}
.calend_title_mes {
  text-transform: capitalize;
}
.v-calendar-weekly__day{
  height: auto;
  text-align: left;

}
.v-calendar-weekly__day-label {
  text-align: left;
  .v-btn__content {
    text-transform: capitalize;
  }
}
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  //background-color: #1867c0;
  color: #ffffff;
  //border: 1px solid #1867c0;
  width: 100%;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
}

.calen_title{
  color: white;
  background-color: #009688;
  height: 70px;
  font-family: Roboto;
  font-size: 15px;
  .calend_title_mes{
    font-weight: 300!important;
  }
}

.calend_body{
  border: 1px solid #25848c;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

//e5e6e6 #009688  #00bcd4

.calendar-progress{
  z-index: 2;
  position: absolute;
}

.overlay{
  background: rgba(255,255,255,0.44);
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}
</style>
